import { render, staticRenderFns } from "./InfoTextDialog.vue?vue&type=template&id=43be3b62"
import script from "./InfoTextDialog.vue?vue&type=script&lang=js"
export * from "./InfoTextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports